import { getData, postData } from '@/utils/http'
import config from '@/config'
export default {
    namespaced: true,
    state: {
        tableLoading: true,
        addLoading: false,
        activeItem: null,
        tableList: [],

        //查询条件
        warehouse:"",
        brand:"",
        type:"",
        code:"",
        status:"",
        pageIndex: 1,
        total: 0
    },
    mutations: {
        CHANGE_TABLE_LOADING(state, tableLoading) {
            state.tableLoading = tableLoading
        },
        CHANGE_ADD_LOADING(state, addLoading) {
            state.addLoading = addLoading
        },
        CHANGE_TABLE_DATA(state, changeData) {
            state.tableList = changeData.data.rows
            state.total = changeData.total
        },
        CHANGE_ACTIVE_ITEM(state, item) {
            state.activeItem = item
        },
        CHANGE_SEARCH_COLL(state, changeData) {
            if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
                state[changeData['changeKey']] = [changeData['data']]
            } else {
                state[changeData['changeKey']] = changeData['data']
            }
        },
        CHANGE_TABLE_INDEX(state, value) {
            state.pageIndex = value
        }
    },
    actions: {
        //获取列表
        getList({ commit, state }) {
            return new Promise(resolve => {
                getData(`logistics/tire/ledger/page`, {
                    page: state.pageIndex,
                    size: config.pageSize,
                    warehouse:state.warehouse,
                    brand:state.brand,
                    type:state.type,
                    code:state.code,
                    status:state.status
                }).then(res => {
                    if (res.state == 1) {
                        commit('CHANGE_TABLE_DATA', res)
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取已经启用的字典值
		getAllowValue({ commit, state },type){
			return new Promise((resolve) => {
				getData(`logistics/sys/dict/data/type/${type}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data:res.data
						});
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						});
					}
				})
			})
		},
        getWarehouseList({ commit, state }, deptId) {
            return new Promise(resolve => {
                getData(`logistics/warehouse/page`, {
                    page:1,
                    size:999999,
                    status:1,
                    name:"",
                    deptId: deptId,
                }).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data:res.data.rows,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data:[],
                            msg: res.msg
                        })
                    }
                })
            })
        },

        //写入当前操作条目
        setActiveItem({ commit }, item) {
            commit('CHANGE_ACTIVE_ITEM', item)
        },

        //写入查询条件
        setSearchData({ commit }, changeData) {
            commit('CHANGE_SEARCH_COLL', changeData)
        },
        //修改分页
        setPageIndex({ commit }, value) {
            commit('CHANGE_TABLE_INDEX', value)
        },
        //修改添加loading
        changeAddLoading({ commit }, value) {
            commit('CHANGE_ADD_LOADING', value)
        },
        //修改添加loading
        changeListLoading({ commit }, value) {
            commit('CHANGE_TABLE_LOADING', value)
        }
    }
}
